export const dashboardColors = {
  windColor: '#111E5C', //blue-shade
  bioGColor: '#63B76C', //green-shade
  pvColor: '#F1B42F', //orange-shade
  surplusColor: '	#49796B', //green-shade
  comsumptionColor: '#7a273b', //red-shade
};
